import apiClient, { API_ENDPOINTS, rejectWithError } from "api";
import { buildDiscussionImageUploadFormData } from "domains/education/services/discussionRequestBuilders";

const { discussion, upload } = API_ENDPOINTS;

const unwrapList = (payload) => payload?.data || [];
const unwrapItem = (payload) => payload?.data || null;
const rejectDiscussionError = (error, label) => rejectWithError(error, label);

export const findDiscussions = (criteria) => async () => {
  try {
    const data = await apiClient.post(discussion.find, criteria);
    return unwrapList(data);
  } catch (error) {
    return rejectDiscussionError(error, "Error finding discussions");
  }
};

export const uploadImage = async (file, companyFolderId) => {
  try {
    return await apiClient.upload(upload.uploadImage, buildDiscussionImageUploadFormData(file, companyFolderId), {
      responseType: "text"
    });
  } catch (error) {
    return rejectDiscussionError(error, "Error uploading discussion image");
  }
};

export const createDiscussion = async (discussionPayload) => {
  try {
    const data = await apiClient.post(discussion.create, discussionPayload);
    return unwrapItem(data);
  } catch (error) {
    return rejectDiscussionError(error, "Error creating discussion");
  }
};

export const updateDiscussion = async (discussionPayload) => {
  try {
    const data = await apiClient.post(discussion.update, discussionPayload);
    return unwrapItem(data);
  } catch (error) {
    return rejectDiscussionError(error, "Error updating discussion");
  }
};

export const findCourseDiscussions = (criteria) => async () => {
  try {
    const data = await apiClient.post(discussion.course, criteria);
    return unwrapList(data);
  } catch (error) {
    return rejectDiscussionError(error, "Error finding course discussions");
  }
};
